import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#00838F',
                secondary: '#006064',
                accent: '#00BCD4',
                anchor: '#00ACC1'
            }
        },
        options: { customProperties: true },
    }
});
